// Shared affiliate-bucket lookup. Consumed by:
//   - src/context/AffiliateBucketContext.js — full bucket state machine
//   - gatsby-browser.js — pre-route redirect on SPA navigation
//   - gatsby-ssr.js — inline <head> script for direct page loads
// Keep this file dependency-free so it can be imported from Gatsby
// framework files at both build time and runtime.

const BUCKET_COOKIE = 'mx_aff_magician'

const AFFILIATE_REDIRECTS = {
  '/weight-loss': '/weight-loss-aff',
  '/weight-loss/tirzepatide-standard': '/weight-loss/tirzepatide-standard-aff',
  '/weight-loss/semaglutide-standard': '/weight-loss/semaglutide-standard-aff',
}

const normalizePath = (pathname) => {
  if (!pathname) return '/'
  if (pathname.length > 1 && pathname.endsWith('/')) return pathname.slice(0, -1)
  return pathname
}

const lookupAffiliateRedirect = (pathname) =>
  AFFILIATE_REDIRECTS[normalizePath(pathname)] || null

// Transform a link href to its -aff variant if its path is in the redirect
// map. Accepts relative (/weight-loss) and absolute (https://...) hrefs;
// preserves origin, search, and hash. Returns the original href untouched
// when there's no redirect for the path.
const applyAffiliateRedirect = (href) => {
  if (!href) return href
  let url
  try {
    url = new URL(href, 'http://placeholder.test')
  } catch {
    return href
  }
  const target = lookupAffiliateRedirect(url.pathname)
  if (!target) return href
  const origin = href.startsWith('/') ? '' : url.origin
  return origin + target + url.search + url.hash
}

module.exports = {
  BUCKET_COOKIE,
  AFFILIATE_REDIRECTS,
  normalizePath,
  lookupAffiliateRedirect,
  applyAffiliateRedirect,
}
